// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-user-edit-work-profile-tab .full-width-material .mat-mdc-form-field {
  width: 100%;
}
.fi-user-edit-work-profile-tab .mat-mdc-form-field-icon-suffix .mat-icon {
  color: var(--fi-color-grey);
  font-size: 18px;
}`, "",{"version":3,"sources":["webpack://./Source/app/user/user-edit/user-edit-new-layout/fi-user-edit-work-profile-tab/fi-user-edit-work-profile-tab.component.scss"],"names":[],"mappings":"AAEQ;EACI,WAAA;AADZ;AAII;EACI,2BAAA;EACA,eAAA;AAFR","sourcesContent":[".fi-user-edit-work-profile-tab {\r\n    .full-width-material {\r\n        .mat-mdc-form-field {\r\n            width: 100%;\r\n        }\r\n    }\r\n    .mat-mdc-form-field-icon-suffix .mat-icon {\r\n        color: var(--fi-color-grey);\r\n        font-size: 18px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
